// src/data/mock.js

export const zones = [
  {
    name: "Docks",
    owner: { name: "Yakuza", color: "#be123c" },
    points: 1120,
    lastCapture: "2025-07-06 15:22",
    captures: [
      { by: "Yakuza", at: "2025-07-06 15:22" },
      { by: "Ballas", at: "2025-07-05 21:44" },
      { by: "Yakuza", at: "2025-07-05 16:11" }
    ]
  },
  {
    name: "Vinewood",
    owner: { name: "Ballas", color: "#a21caf" },
    points: 3040,
    lastCapture: "2025-07-06 13:45",
    captures: [
      { by: "Ballas", at: "2025-07-06 13:45" },
      { by: "Grove", at: "2025-07-05 20:21" }
    ]
  },
  {
    name: "Grove",
    owner: { name: "Vagos", color: "#ca8a04" },
    points: 2500,
    lastCapture: "2025-07-06 12:30",
    captures: [
      { by: "Vagos", at: "2025-07-06 12:30" },
      { by: "Ballas", at: "2025-07-05 11:10" }
    ]
  }
];

// wylicz ranking gangów
export function getOrganizations(zones) {
  const orgs = {};
  zones.forEach(z => {
    const name = z.owner.name;
    if (!orgs[name]) orgs[name] = { name, color: z.owner.color, points: 0 };
    orgs[name].points += z.points;
  });
  return Object.values(orgs).sort((a, b) => b.points - a.points);
}

// lista wszystkich przejęć (do "ostatnie przejęcia")
export function getRecentCaptures(zones, limit = 10) {
  let captures = [];
  zones.forEach(z => {
    z.captures.forEach(c => {
      captures.push({ zone: z.name, by: c.by, at: c.at });
    });
  });
  // od najnowszych
  return captures.sort((a, b) => b.at.localeCompare(a.at)).slice(0, limit);
}
